import React from "react";

const _PlaceIcon = ({ className = "" }) => (
    <svg
        width="14"
        height="19"
        viewBox="0 0 14 19"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M3.91211 6.82411C3.91211 7.59649 4.21893 8.33723 4.76509 8.88338C5.31124 9.42954 6.05198 9.73636 6.82436 9.73636C7.59673 9.73636 8.33748 9.42954 8.88363 8.88338C9.42978 8.33723 9.73661 7.59649 9.73661 6.82411C9.73661 6.05174 9.42978 5.311 8.88363 4.76484C8.33748 4.21869 7.59673 3.91187 6.82436 3.91187C6.05198 3.91187 5.31124 4.21869 4.76509 4.76484C4.21893 5.311 3.91211 6.05174 3.91211 6.82411Z"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M6.8245 1C8.36925 1 9.85073 1.61365 10.943 2.70596C12.0353 3.79826 12.649 5.27974 12.649 6.8245C12.649 9.47037 8.70853 16.1049 7.30987 18.2133C7.25674 18.2934 7.18461 18.3591 7.09992 18.4046C7.01523 18.45 6.92061 18.4738 6.8245 18.4738C6.72838 18.4738 6.63376 18.45 6.54907 18.4046C6.46438 18.3591 6.39225 18.2934 6.33912 18.2133C4.94047 16.1049 1 9.47037 1 6.8245C1 5.27974 1.61365 3.79826 2.70596 2.70596C3.79826 1.61365 5.27974 1 6.8245 1V1Z"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export const PlaceIcon = React.memo(_PlaceIcon);